import BostadRentLink from './BostadRentLink'

export default BostadRentLink
